import { render, staticRenderFns } from "./UserAccessControl.vue?vue&type=template&id=72904828&scoped=true"
import script from "./UserAccessControl.vue?vue&type=script&lang=js"
export * from "./UserAccessControl.vue?vue&type=script&lang=js"
import style0 from "./UserAccessControl.vue?vue&type=style&index=0&id=72904828&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72904828",
  null
  
)

export default component.exports